module.exports = __webpack_public_path__ + "img/empty-boards.15b7af57.gif";